<template>
  <div class="app-container statistics-list">
    <div class="statistics-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="statistics-list-filter-value" v-model.trim="search.keyword" @keyup.enter.native="searchChange" placeholder="课程名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="statistics-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="statistics-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class="statistics-list-container">
      <avue-crud ref="crud"
                 :option="tableOption"
                 :data="list"
                 :page="page"
                 :table-loading="listLoading"
                 @current-change="handleCurrentChange"
                 @refresh-change="handleRefreshChange"
                 @size-change="handleSizeChange"
                 @sort-change="handleSortChange">

        <template slot="menuLeft">
          <el-button
            class="filter-item"
            v-if="permissions.course_export"
            @click="handleExport()"
            size="small"
            type="primary"
            :loading="exportLoading"
            icon="el-icon-download">{{exportName}}
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
  import { fetchCourseStatisticsSummary, exportCourseStatisticsSummary } from '@/api/analysis/courseAnalysis'
  import { exporting } from '@/util/exportUtil'
  import { tableOption } from '@/const/crud/analysis/courseAnalysis'
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        search: {
          current: 1,
          size: 10,
          keyword: '',
          sortField: '',
          sortPolicy: '',
        },
        exportLoading: false,
        exportName: '导出',
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
        },
        tableOption: tableOption,
        listLoading: false,
        form: {},
      };
    },
    activated () {
      this.initPage()
      this.getStatisticsSummaryData()
    },
    async created() {
      await this.initPage()
      await this.getStatisticsSummaryData()
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    methods: {
      getStatisticsSummaryData() {
        let params = {
          current: this.search.current,
          size: this.search.size,
        }
        if (this.search.keyword != '' && this.search.keyword.trim() != '')
          params.keyword = this.search.keyword
        
        if (this.search.sortField != '' && this.search.sortField.trim() != '')
          params.sortField = this.search.sortField
        else {
          params.sortField = 'id'
        }
        if (this.search.sortPolicy != '' && this.search.sortPolicy.trim() != '')
          params.sortPolicy = this.search.sortPolicy
        else {
          params.sortPolicy = 'desc'
        }
        this.listLoading = true
        fetchCourseStatisticsSummary(params).then(response => {
          this.list = response.data.data.records
          this.page.total = response.data.data.total
          this.listLoading = false
        });
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
      },
      searchChange() {
        this.initPage()
        this.getStatisticsSummaryData()
      },
      searchReset() {
        this.search.keyword = ''
        this.searchChange()
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getStatisticsSummaryData()
      },
      handleRefreshChange() {
        this.getStatisticsSummaryData()
      },
      handleSizeChange(val) {
        this.page.pageSize = val
        this.page.currentPage = 1
        this.search.size = val
        this.search.current = 1
        this.getStatisticsSummaryData()
      },
      handleSortChange(val) {
        if (val.prop == 'participationCount') {
          this.search.sortField = 'participation_count'
        } else if (val.prop == 'completedCount') {
          this.search.sortField = 'completed_count'
        } else {
          this.search.sortField = 'id'
        }
        if (val.order == 'ascending') {
          this.search.sortPolicy = 'asc'
        } else if (val.order == 'descending') {
          this.search.sortPolicy = 'desc'
        } else {
          this.search.sortField = 'id'
          this.search.sortPolicy = 'desc'
        }
        this.getStatisticsSummaryData()
      },
      handleExport() {
        let params = {}
        if (this.search.keyword != '' && this.search.keyword.trim() != '')
          params.keyword = this.search.keyword
        
        if (this.search.sortField != '' && this.search.sortField.trim() != '')
          params.sortField = this.search.sortField
        else {
          params.sortField = 'id'
        }
        if (this.search.sortPolicy != '' && this.search.sortPolicy.trim() != '')
          params.sortPolicy = this.search.sortPolicy
        else {
          params.sortPolicy = 'desc'
        }
        exportCourseStatisticsSummary(params).then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            this.exportLoading = true
            this.exportName = '导出中...'
            exporting(response.data.data, this.exportCallback)
          } else {
            this.$message({
              message: '数据导出失败',
              type: 'warning',
              showClose: true,
            });
          }
        });
      },
      exportCallback(result) {
        this.exportLoading = false
        this.exportName = '导出'
        if (result) {
          this.$message({
            showClose: true,
            message: '导出完成',
            type: 'success'
          })
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
.statistics-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-empty {
      display: block;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-location-value {
      width: calc(100% - 12px) !important;
      input {
        border: none !important;
      }
    }
    &-date {
      width: 96%!important;
    }
    &-search {
      float: right;
      margin-right: 10px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
</style>
